module.exports = __webpack_public_path__ + "static/img/applicableScene5.ecb1033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene5.png
// module id = se7B
// module chunks = 0